/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import styled from 'styled-components'
import Text from '../atomic/Text'

const StyledMainTitle = styled(Text)`
  font-weight: var(--typography-weight-black);
  margin-right: var(--spacing-margin-xSmall);
  font-size: var(--app-subheader-fontsize-s2, --typography-size-s2);
  color: var(${({ color }: { color: string }) => color}, var(--color-black));
`

const TitleLogic = ({ Wrapper, title }: { Wrapper: any; title: string }) => {
  const { colorSubheader: color } = useHeaderContext()
  return <Wrapper text={title} color={color} />
}

const Title = ({ title }: { title: string }) => (
  <TitleLogic Wrapper={StyledMainTitle} title={title} />
)

export default Title
